var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62631 6.39212L2.75987 6.24186C3.24938 5.72998 3.97863 5.47388 4.94695 5.47388H21.5421C22.4546 5.47388 23.1558 5.69659 23.6457 6.14169L23.6624 6.15838C23.7625 6.24754 23.863 6.35305 23.9629 6.47559C23.9629 6.48695 23.9686 6.49797 23.9796 6.50899L23.9963 6.52568C24.3639 6.98213 24.5472 7.62757 24.5472 8.46233V17.9119C24.5362 19.9153 23.5345 20.917 21.5421 20.917H4.94695C2.95454 20.906 1.9585 19.9043 1.9585 17.9119V8.46233C1.9585 7.56079 2.18121 6.87061 2.62631 6.39212ZM22.093 7.11002C21.9261 7.06561 21.7424 7.04858 21.5424 7.05993H4.94695C4.82441 7.04891 4.70754 7.05425 4.59635 7.07663L13.1944 15.7916L22.093 7.11002ZM3.54455 8.27869C3.53353 8.33445 3.53353 8.39555 3.54455 8.46233V17.9119C3.54455 18.8582 4.01202 19.331 4.94695 19.331H21.5421C22.488 19.331 22.9612 18.8582 22.9612 17.9119V8.47903L13.7454 17.4778C13.5784 17.6337 13.3894 17.7115 13.1781 17.7115C12.9554 17.7005 12.766 17.6224 12.6104 17.4778L3.54455 8.27869Z",
    fill: "#0D6EFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62646 6.39196C2.64884 6.35857 2.67655 6.32518 2.70994 6.29178C2.72129 6.26941 2.73765 6.25272 2.76003 6.2417L2.62646 6.39196Z",
    fill: "#0D6EFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.05a5562458d490c03f90d8beab2962aa.svg";
export { ForwardRef as ReactComponent };